import FeatureRendererType from '@jbrowse/core/pluggableElementTypes/renderers/FeatureRendererType';
import ReactComponent from './components/DivSequenceRendering';
import configSchema from './configSchema';
/* adjust in both directions */
class DivSequenceRenderer extends FeatureRendererType {
    constructor() {
        super(...arguments);
        this.supportsSVG = true;
    }
    getExpandedRegion(region) {
        return {
            ...region,
            start: Math.max(region.start - 3, 0),
            end: region.end + 3,
        };
    }
}
export default function DivSequenceRendererF(pluginManager) {
    pluginManager.addRendererType(() => new DivSequenceRenderer({
        name: 'DivSequenceRenderer',
        ReactComponent,
        configSchema,
        pluginManager,
    }));
}
